import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LocalService} from '../services/local.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  httpHeaderOptions: any;

  constructor(public _http: HttpClient, private localService: LocalService) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
  }

  addUser(data: any) {
    return this._http.post(environment.apiEndpoint + 'add_user/', data);
  }

  updateUserDetails(id: number, data: any) {
    return this._http.put(environment.apiEndpoint + 'edit_user_new/' + id + '/', data);
  }

  getUsers() {
    return this._http.get(environment.apiEndpoint + 'user-module-role_list/', this.httpHeaderOptions);
  }

  userList(page, str, field, order) {
    return this._http.get(environment.apiEndpoint + 'user_module_list/?page=' + page + '&search=' + str + '&field_name=' + field + '&order_by=' + order, this.httpHeaderOptions);
  }

  getfreeroles(appid: any) {
    return this._http.get(environment.apiEndpoint + 'free_role-module_list/' + appid + '/', this.httpHeaderOptions);
  }

  getApplicationRoles(appid: any) {
    return this._http.get(environment.apiEndpoint + 'role-module_list/' + appid + '/', this.httpHeaderOptions);
  }

  logout() {
    return this._http.get(environment.apiEndpoint + 'logout/', this.httpHeaderOptions);
  }

  lockunlock(str) {
    return this._http.put(environment.apiEndpoint + 'user_lock_unlock/' + str.id + '/', str, this.httpHeaderOptions);
  }

  changepass(str) {
    return this._http.put(environment.apiEndpoint + 'change_password/', str, this.httpHeaderOptions);
  }

  getUserDetails() {
    return this._http.get(environment.apiEndpoint + 'user_edit/' + this.localService.getJsonValue('userid') + '/', this.httpHeaderOptions);
  }

  getEmployeeDetails(params) {
    return this._http.get(environment.apiEndpoint + 'employee_edit/'+this.localService.getJsonValue('userid')+'/?'+params, this.httpHeaderOptions);
  }

  userDetails(uid) {
    return this._http.get(environment.apiEndpoint + 'user_edit/' + uid + '/', this.httpHeaderOptions);
  }

  otherProfileUpdate(uid, str) {
    return this._http.put(environment.apiEndpoint + 'user_edit/' + uid + '/', str, this.httpHeaderOptions);
  }

  updateUser(str) {
    return this._http.put(environment.apiEndpoint + 'user_edit/' + this.localService.getJsonValue('userid') + '/', str, this.httpHeaderOptions);
  }

  getUserInfo(id) {
    return this._http.get(environment.apiEndpoint + 'user_permission_edit/' + id + '/', this.httpHeaderOptions);
  }

  permissionListByUser(app, id) {
    return this._http.get(environment.apiEndpoint + 'other_list_with_permission_by_user_module_name/' + app + '/' + id + "/", this.httpHeaderOptions);
  }

  assignUserPermission(data) {
    return this._http.post(environment.apiEndpoint + 'assign_permission_to_user_add_or_update_new/', data, this.httpHeaderOptions);
  }

  getUserAllDetails(id) {
    return this._http.get(environment.apiEndpoint + 'edit_user_get_new/' + id + '/', this.httpHeaderOptions);
  }

  getUserList(params) {
    return this._http.get(environment.apiEndpoint + 'user_module_list/?' + params, this.httpHeaderOptions);
  }

  getUserListWP() {
    return this._http.get(environment.apiEndpoint + 'employee_list_wo_pagination/', this.httpHeaderOptions);
  }

  getGradeList() {
    return this._http.get(environment.apiEndpoint + 'grade_add/', this.httpHeaderOptions);
  }

  getQualificationMaster(){
    return this._http.get(environment.apiEndpoint + 'qualification_master_add/', this.httpHeaderOptions);
  }

  academicQualificationAdd(data:any){
    return this._http.post(environment.apiEndpoint + 'hrms_employee_academic_qualification_add/', data);
  }
  academicQualificationDocAdd(data:any){
    return this._http.post(environment.apiEndpoint + 'hrms_employee_academic_qualification_document_add/', data);
  }
  addPersonalTabDocument(data: any) {
    return this._http.post(environment.apiEndpoint + 'hrms_employee_profile_document_add/', data);
  }
  updateEmployeeRole(id: any,params, data: any) {
    return this._http.put(environment.apiEndpoint + 'employee_edit/' + id + '/?'+params, data)
  }

  academicQualificationDelete(id: number) {
    return this._http.put(environment.apiEndpoint + 'hrms_employee_academic_qualification_delete/' + id  + '/', {}, this.httpHeaderOptions)
  }
  deleteProfileDocument(id: number) {
    return this._http.put(environment.apiEndpoint + 'hrms_employee_profile_document_delete/' + id  + '/', {}, this.httpHeaderOptions)
  }

  monthlyLeaveDetails(param){
    return this._http.get(environment.apiEndpoint + 'v2/attendance_grace_leave_month_wise/?'+param, this.httpHeaderOptions);
  }

  graceLeaveListV2(param){
    return this._http.get(environment.apiEndpoint + 'v2/attendance_grace_leave_list_first_modified/?'+param, this.httpHeaderOptions);
  }
  flexiGraceLeaveListV2(param){
    return this._http.get(environment.apiEndpoint + 'v2/flexi_attendance_grace_leave_list_first_modified/?'+param, this.httpHeaderOptions);
  }

  updateTransporterData(id: any, data: any) {
    return this._http.put(environment.apiEndpoint + 'sscrm/transporter/user/edit/' + id + '/', data)
  }

  empDetails(param:any){
    return this._http.get(environment.apiEndpoint + 'v2/employee_list_without_details/?' + param,this.httpHeaderOptions)
  }
}
